import React, { lazy } from 'react';
import { useTranslation } from '../../lib/i18n';
type Partner = {
  name: string;
  logo: string;
};
export function References() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  // Forza Properties stays centered (middle of the array).
  const partners: Partner[] = [{
    name: 'Auto Centar 7',
    logo: 'https://cdn.magicpatterns.com/uploads/1fqM9kKbe2hFhrra1ojcUq/2.png'
  }, {
    name: 'Forza Properties',
    logo: 'https://cdn.magicpatterns.com/uploads/9DuJDoXqE3yscoFZMSV47t/1.png'
  }, {
    name: 'Optika Lučić',
    logo: 'https://cdn.magicpatterns.com/uploads/oDp4YLLs6PRiVX4c2Ewa3f/3.png'
  }];
  return <section className="py-5 md:py-6 bg-dark-bg" data-id="element-293">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <h2 className="text-center text-xl sm:text-3xl md:text-4xl font-black tracking-tight mb-5 sm:mb-6 md:mb-8" data-id="element-295">
          {en ? <>
              Our <span className="text-brand-yellow" data-id="element-296">clients</span>
            </> : ru ? <>
              Наши <span className="text-brand-yellow" data-id="element-297">клиенты</span>
            </> : <>
              Naši <span className="text-brand-yellow" data-id="element-298">klijenti</span>
            </>}
        </h2>

        <ul className="flex flex-nowrap justify-center items-center gap-x-4 sm:gap-x-10 md:gap-x-14" data-id="element-299">
          {partners.map(partner => <li key={partner.name} className="flex items-center justify-center min-w-0" data-id="element-300">
              <span className="group inline-flex transition-transform duration-300 hover:scale-105" data-id="element-301">
                <img src={partner.logo} alt={partner.name} loading="lazy" className="h-14 sm:h-20 md:h-28 w-auto max-w-[30vw] sm:max-w-none object-contain brightness-0 invert opacity-80 transition-all duration-[400ms] group-hover:brightness-100 group-hover:invert-0 group-hover:opacity-100" data-id="element-302" />
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}